import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-seamless-transitions',
  imports: [PillarPagesTemp],
  templateUrl: './seamless-transitions.html',
  styleUrl: './seamless-transitions.scss',
})
export class SeamlessTransitions {

}
